import { createContext } from 'react';

import { AuthenticationContextValues } from './types';

const AuthenticationContext = createContext<
  AuthenticationContextValues | undefined
>(undefined);

export default AuthenticationContext;
